import styled from "styled-components"

const Wrap = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 25px;
    gap: 0 20px;
`;

const Total = styled.div`
    font-size: 16px;

    > span {
        font-size: 18px;
        font-weight: bold;
    }
`;

const ButtonContainer = styled.div`
    position: absolute;
    right: 0;
    display: flex;
    gap: 0 8px;

    button {
        display: flex;
        align-items: center;
        gap: 0 5px;
    }
`;

function ButtonBox({children, ...props}) {

    return (
        <ButtonContainer {...props}>
            {children}
        </ButtonContainer>
    );
}

function TableHeader({children, total, ...props}) {
    return (
        <Wrap {...props}>
            <Total>
                총 <span>{total}</span>개
            </Total>
            {children}
        </Wrap>
    )
}

TableHeader.ButtonBox = ButtonBox;
export default TableHeader;